<template>
	<div>
		<b-row>
			<b-col md="6">
				<b-input
					v-model="passwordOld"
					type="password"
					placeholder="Aktuelles Passwort"
				/>
			</b-col>
		</b-row>
		<Password
			v-model="passwordNew"
			ref="password"
			placeholder1="Neues Passwort"
			placeholder2="Neues Passwort (wiederholen)"
		/>
		<div class="text-right mt-4">
			<Button
				text="Passwort ändern"
				:disabled="!dataValid ||changing"
				:loading="changing"
				icon="checkmark"
				@click="change"
			/>
		</div>
	</div>
</template>

<script>
import Password from "@/vue/common/form/Password";
import Button from "@/vue/common/Button";
import {isDefined} from "@/helper/Value";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import Group from "@/vue/common/form/Group.vue";
import Change from "@/api/auth/password/Change";
import {isEmptyOrNull} from "@/helper/String";

export default {
	components: {
		Group,
		Button,
		Password
	},

	data ()
	{
		return {
			passwordOld: '',
			passwordNew: undefined,
			changing: false,
		};
	},

	computed: {
		dataValid ()
		{
			return !isEmptyOrNull(this.passwordOld) && isDefined(this.passwordNew);
		},
	},

	methods: {
		async change ()
		{
			this.changing = true;

			try
			{
				await new Change()
					.setPasswordOld(this.passwordOld)
					.setPasswordNew(this.passwordNew)
					.call();

				Toast.success(this, ['Passwort erfolgreich geändert']);

				this.passwordOld = '';

				this.$refs.password.reset();
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.changing = false;
		}
	}
}
</script>
